<template>
  <div>
    <v-select
      v-model="selectedHour"
      :items="allowedHours"
      class="pull-left mt-0 pt-0 time-selector"
    ></v-select>
    <span class="pull-left mx-3 time-colon">:</span>
    <v-select
      v-model="selectedMinute"
      :items="allowedMinutes"
      class="pull-left mt-0 pt-0 time-selector"
    ></v-select>
    <div class="clearfix"></div>
  </div>
</template>

<script>
const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "TimeSelector",
  components: {},
  props: {
    time: {
      type: String,
    },
  },
  data() {
    const allowedHours = [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
    ];
    return {
      selectedHour: allowedHours[new Date().getHours()],
      selectedMinute: "00",
      allowedMinutes: ["00", "30"],
      allowedHours: allowedHours,
    };
  },
  methods: {},
  watch: {
    selectedHour() {
      if (this.selectedHour && this.selectedMinute) {
        this.$emit(
          EMITTED_ACTIONS.CHANGE,
          `${this.selectedHour}:${this.selectedMinute}`
        );
      }
    },
    selectedMinute() {
      if (this.selectedHour && this.selectedMinute) {
        this.$emit(
          EMITTED_ACTIONS.CHANGE,
          `${this.selectedHour}:${this.selectedMinute}`
        );
      }
    },
    time: {
      handler(newVal, oldVal) {
        if (this.time) {
          const parts = this.time.split(":");
          if (parts && Array.isArray(parts) && parts.length === 2) {
            this.selectedHour = parts[0];
            this.selectedMinute = parts[1];
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style>
.time-selector {
  width: 80px;
}
.time-colon {
  font-size: 24px;
  position: relative;
  top: -5px;
}
</style>
